import React from "react";
import SopeOfWorkBg from "../../../certificates/ScopeOfWork.jpg";
const ScopeOfWork = ({
  quotationType = null,
  a_FramePercent,
  flatBedPercent,
  growBagPercent,
  dutchBucketPercent,
}) => {
  let serial = 1;
  return (
    <div style={{ pageBreakInside: "avoid" }}>
      <h3 style={{ marginTop: "40px" }}>Scope of Work</h3>
      <p className="fs-3 mb-0">Specifications :</p>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Item</th>
            <th>Description / Specification</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{serial++}.</td>
            <td>Procurement</td>
            <td>
              KBPL will procure all raw material to KBPL factory as per the
              requirement of modification and structure.
            </td>
          </tr>
          <tr>
            <td>{serial++}.</td>
            <td>Modifications</td>
            <td>
              KBPL will modify the raw materials as per requirement of the
              project at our factory location.
            </td>
          </tr>
          <tr>
            <td>{serial++}.</td>
            <td>Transportation of raw material</td>
            <td>
              KBPL will transport all raw material at its own expense before the
              modification and for in work transit.
            </td>
          </tr>
          <tr>
            <td>{serial++}.</td>
            <td>Quality analysis</td>
            <td>
              KBPL will conduct all Quality Analysis at factory location and
              modify / redo the work if required.
            </td>
          </tr>
          {(quotationType?.includes("fanpad") ||
            quotationType?.includes("nethouse") ||
            quotationType?.includes("nvph")) && (
            <tr>
              <td>{serial++}.</td>
              <td>Foundation installation</td>
              <td>Foundation installation will be in scope of KBPL.</td>
            </tr>
          )}

          {(quotationType?.includes("fanpad") ||
            quotationType === "soilbasedfanpad") && (
            <tr>
              <td>{serial++}.</td>
              <td>Installation of fanpad</td>
              <td>
                Installation of Fanpad is from GI skeleton to Plastic sheet and
                shade net is in scope of KBPL.
              </td>
            </tr>
          )}
          {growBagPercent > 0 && (
            <>
              <tr>
                <td>{serial++}.</td>
                <td>Grow bags installation</td>
                <td>
                  Installation of growbags and drip system is in scope of KBPL.
                </td>
              </tr>
            </>
          )}
          {dutchBucketPercent > 0 && (
            <>
              <tr>
                <td>{serial++}.</td>
                <td>Dutch bucket installation</td>
                <td>
                  Installation of dutch buckets and drip system is in scope of
                  KBPL.
                </td>
              </tr>
            </>
          )}
          {(dutchBucketPercent > 0 || growBagPercent > 0) && (
            <tr>
              <td>{serial++}.</td>
              <td>Trellising system</td>
              <td>Trellising system support will be provided by KBPL.</td>
            </tr>
          )}
          {flatBedPercent > 0 && (
            <>
              <tr>
                <td>{serial++}.</td>
                <td>Frame installation &amp; NFT pipes</td>
                <td>
                  Installation of frames and NFT pipes is in scope of KBPL.
                </td>
              </tr>
            </>
          )}
          {a_FramePercent > 0 && (
            <>
              <tr>
                <td>{serial++}.</td>
                <td>Frame installation</td>
                <td>Installation of frames is in scope of KBPL.</td>
              </tr>
            </>
          )}
          {(flatBedPercent > 0 || a_FramePercent > 0) && (
            <tr>
              <td>{serial++}.</td>
              <td>Plumbing work</td>
              <td>
                Complete plumbing work, to all frames pipes to tanks is in scope
                of KBPL.
              </td>
            </tr>
          )}
          {quotationType !== "nvph" && quotationType !== "soilbasednvph" && (
            <tr>
              <td>{serial++}.</td>
              <td>Installation of water tank</td>
              <td>
                Installation and plumbing of the water tank in scope of KBPL.
              </td>
            </tr>
          )}
          <tr>
            <td>{serial++}.</td>
            <td>Final on-site QA</td>
            <td>
              Final on-site QA will be done by KBPL team. We insist you to be
              present at QA process to take the complete overview of operations
              and understanding of project.
            </td>
          </tr>
          <tr>
            <td>{serial++}.</td>
            <td>Handover</td>
            <td>
              Delivery of working conditions as per quotation description will
              be considered as project ready for handover.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ScopeOfWork;
